import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
import ProjectDetail from "@/pages/ProjectDetail";
import { projectBySlugQuery } from "@/lib/publicQueries";
import { clip, seoHead } from "@/lib/seo";

const LEISTUNG: Record<string, string> = {
  photography: "Fotografie",
  videography: "Videoproduktion",
  "social-media": "Social Media",
};

export const Route = createFileRoute("/portfolio/$slug")({
  loader: async ({ context, params }) => {
    // Old project addresses used the database id; they permanently redirect to the portfolio.
    if (UUID_RE.test(params.slug)) throw redirect({ to: "/portfolio", statusCode: 301 });
    let project;
    try {
      project = await context.queryClient.ensureQueryData(projectBySlugQuery(params.slug));
    } catch (err) {
      // Fetch failed: render the page with the German error message instead of a 404
      console.error("Project loader failed:", err);
      return { seo: null };
    }
    if (!project) throw notFound();
    const cover = project.coverImage?.startsWith("video::")
      ? project.images?.find((img: string) => !img.startsWith("video::"))
      : project.coverImage;
    return {
      seo: {
        title: project.title,
        category: project.category as string,
        description: project.description || "",
        image: cover ?? null,
      },
    };
  },
  head: ({ loaderData, params }) => {
    const seo = loaderData?.seo;
    if (!seo) {
      return {
        meta: [{ title: "Projekt | Clicks DMP" }, { name: "robots", content: "noindex" }],
      };
    }
    const suffix = ` | ${LEISTUNG[seo.category] ?? "Fotografie"} | Clicks DMP`;
    const title = clip(seo.title, 60 - suffix.length) + suffix;
    const description = clip(seo.description || seo.title, 150);
    return seoHead({ title, description, path: `/portfolio/${params.slug}`, image: seo.image });
  },
  component: ProjectDetail,
});
